<template>
  <div>
    <nav class="header-contacts__social">
      <a href="viber://pa?chatURI=dnipro_m_bot" class="header-contacts__social-item">
        <span class="header-contacts__social-item__icon">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-viber'"></use>
          </svg>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-viber-h'"></use>
          </svg>
        </span>
        <span>Viber</span>
      </a>
      <a target="_blank" href="https://telegram.me/dnipro_m_bot" class="header-contacts__social-item">
        <span class="header-contacts__social-item__icon">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-telegram'"></use>
          </svg>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-telegram-h'"></use>
          </svg>
        </span>
        <span>Telegram</span>
      </a>
      <a target="_blank" href="https://m.me/795514890478433" class="header-contacts__social-item">
        <span class="header-contacts__social-item__icon">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-facebook'"></use>
          </svg>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-facebook-h'"></use>
          </svg>
        </span>
        <span>Facebook</span>
      </a>
      <a href="mailto:support@dnipro-m.ua" class="header-contacts__social-item">
        <span class="header-contacts__social-item__icon">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-email'"></use>
          </svg>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-email-h'"></use>
          </svg>
        </span>
        <span>E-mail</span>
      </a>
      <a href="javascript:void(0)" @click="openChat()" class="header-contacts__social-item">
        <span class="header-contacts__social-item__icon">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-chat'"></use>
          </svg>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-chat-h'"></use>
          </svg>
        </span>
        <span>{{ $t('header_sidebar_chat') }}</span>
      </a>
    </nav>
    <div class="header-contacts__phone-wrap">
      <a href="tel:0800200500" class="header-contacts__social-item">
        <span class="header-contacts__social-item__icon">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-phone'"></use>
          </svg>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-phone-h'"></use>
          </svg>
        </span>
        <span>0 800 200 500</span>
      </a>
      <div class="header-contacts__phone-info">{{ $t('header_sidebar_free_in_ukraine') }}</div>
    </div>
  </div>
</template>

<script>
import { spritePath } from '@/mixins/spritePath'
export default {
  mixins: [spritePath],
  name: 'HeaderContacts',
  methods: {
    openChat () {
      if (localStorage.getItem('zDChatStatus') === 'loaded' && this.$zendesk.isZe()) {
        this.$zendesk.open()
      } else {
        this.initChat()
      }
    },
    initChat () {
      this.$zendesk.load(process.env.VUE_APP_ZENDESK_KEY)
      if (localStorage.getItem('zDChatStatus') !== 'loaded') {
        let ttl = new Date()
        ttl.setHours(ttl.getHours() + 1)

        localStorage.setItem('zDChatStatusExpire', ttl.getTime())
        localStorage.setItem('zDChatStatus', 'loaded')
      }
    }
  },
  mounted () {
    const now = new Date()
    if (localStorage.getItem('zDChatStatusExpire') && localStorage.getItem('zDChatStatusExpire') < now.getTime()) {
      localStorage.removeItem('zDChatStatus')
      localStorage.removeItem('zDChatStatusExpire')
    }
    // Время через которое начнет инициализироваться чат Zendesk
    // let timeOutChatLoading = 0
    // if (localStorage.getItem('zDChatStatus') === 'loaded') {
    //   timeOutChatLoading = 3000
    // } else {
    //   timeOutChatLoading = 20000
    // }
    // setTimeout(() => {
    //   this.initChat()
    // }, timeOutChatLoading)
    this.initChat()
  },
  created () {
    this.$zendesk.$on('loaded', () => {
      if (this.user && this.user.auth && this.user.user_data) {
        this.$zendesk.identify({
          name: (!this.user.user_data.name && !this.user.user_data.last_name) ? '' : this.user.user_data.name + ' ' + this.user.user_data.last_name,
          email: (this.user.user_data.email) ? this.user.user_data.email : '',
          phone: (this.user.user_data.phone) ? this.user.user_data.phone : ''
        })
      }

      this.$zendesk.setLocale(this.language)
    })
  }
}
</script>
